const regex = {
    liveValidation: {
      anyFormatSerialNumber: /(^[Aa](\d{0,9}$))|(^(\d{1,9}$))/,
      oldFormatSerialNumber: /(^[Aa](\d{0,9}$))/,
      newFormatSerialNumber: /(^\d{1,9}$)/
    },
    fullValidation: {
      anyFormatSerialNumber: /(^[Aa]\d{9}$)|(^\d{9}$)/,
      oldFormatSerialNumber: /(^[Aa]\d{9}$)/,
      newFormatSerialNumber: /(^\d{9}$)/
    },
    thousandsSeparator: /(\d{3})(?=\d)/g
  };
   /* istanbul ignore next */
  const formatRut = _rut_ => {
    let result;
     /* istanbul ignore next */
    if (_rut_) {
      let rut = sanitizeRut(_rut_);
  
      result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1);
      for (let i = 4; i < rut.length; i += 3) {
        result = rut.slice(-3 - i, -i) + "." + result;
      }
    }
    return result;
  };
  
  const clean = _str_ => {
     /* istanbul ignore next */
    return typeof _str_ === "string"
      ? _str_.replace(/^(?:0+|[^0-9kK]+)/g, "").toUpperCase()
      : "";
  };
  
  const isValidRut = _str => {
    let str = _str;
    /* istanbul ignore next */
    if (typeof str !== "string") return false;
  
    str = clean(str).toUpperCase();
    let t = parseInt(str.slice(0, -1), 10);
    let m = 0;
    let s = 1;
  
    while (t > 0) {
      s = (s + (t % 10) * (9 - (m % 6))) % 11;
      m += 1;
      t = Math.floor(t / 10);
    }
     /* istanbul ignore next */
    const v = s > 0 ? `${s - 1}` : "K";
    return v === str.slice(-1);
  };
  
  const sanitizeRut = _str_ => {
    return typeof _str_ === "string"
      ? _str_.replace(/^(?:0+|[^0-9kK]+)/g, "").toUpperCase()
      : "";
  };
  /* istanbul ignore next */
   const _isOldFormatSerialNumber = _serialNumber => 
    regex.oldFormatSerialNumber.test(_serialNumber);
  
  const _isNewFormatSerialNumber = (_serialNumber, _isLiveValidation = false) => {
    /* istanbul ignore next */
    if (_isLiveValidation)
      return new RegExp(regex.liveValidation.newFormatSerialNumber, "gm").test(
        _serialNumber
      );
    /* istanbul ignore next */
    return new RegExp(regex.fullValidation.newFormatSerialNumber, "gm").test(
      _serialNumber
    );
  }; 
  
  const isValidSerialNumber = (_serialNumber, _isLiveValidation = false) => {
    if (_isLiveValidation)
      return new RegExp(regex.liveValidation.anyFormatSerialNumber, "gm").test(
        _serialNumber
      );
  
    return new RegExp(regex.fullValidation.anyFormatSerialNumber, "gm").test(
      _serialNumber
    );
  };
  /* istanbul ignore next */
  const formatSerialNumber = _serialNumber => {
    const unmaskedSerialNumber = _serialNumber.replace(/\./g, "");
  
    return _isNewFormatSerialNumber(unmaskedSerialNumber, true)
      ? _serialNumber.replace(/\./g, "").replace(regex.thousandsSeparator, "$&.")
      : _serialNumber.toUpperCase();
  };
  
  export { formatRut, isValidRut, isValidSerialNumber, formatSerialNumber };
  